import PropTypes from "prop-types"
import React from "react"

import './projectCard.scss'

const getClassName =(modifier) =>{
    return (modifier)? "projectCard__wrapper projectCard__wrapper--"+modifier : "projectCard__wrapper";
}

const ProjectCard = ({ title, description,url,modifier }) => (
    <div className={getClassName(modifier)}>
        <a className="projectCard__title"  href={url} target={url? "_blank" : ""}>{title}</a>
        <div className="projectCard__description">{description}</div>
    </div>
)

ProjectCard.propTypes = {
  siteTitle: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  modifier: PropTypes.string,
}

ProjectCard.defaultProps = {
  title: `Project Title`,
  description: `Project Description`,
  url: ``,
  modifier: ``,
}

export default ProjectCard